import { Component, Input, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardService } from '../../../../../../core/services/clipboard/clipboard.service';

export interface LogisticsCardField {
  label: string;
  value: string | number | null | undefined;
}

@Component({
  selector: 'app-logistics-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (visibleFields().length > 0) {
      <div class="rounded-xl border border-neutral-200 bg-neutral-50 p-5 dark:border-neutral-700 dark:bg-neutral-900/40">
        <div class="mb-2.5 text-base font-semibold text-neutral-900 dark:text-white">{{ title }}</div>
        <div class="grid grid-cols-1 gap-2.5">
          @for (field of visibleFields(); track field.label) {
            <div class="flex flex-col gap-0.5">
              <button
                type="button"
                (click)="copyValue(field.value)"
                [title]="'Copiar ' + field.label"
                class="flex w-fit max-w-full cursor-pointer items-center bg-transparent p-0 text-left text-xs tracking-wide text-neutral-500 focus-visible:outline-none dark:text-neutral-400"
              >
                <span class="truncate">{{ field.label }}</span>
              </button>
              <div class="text-sm text-neutral-900 dark:text-neutral-100">{{ field.value }}</div>
            </div>
          }
        </div>
      </div>
    }
  `,
})
export class LogisticsCardComponent {
  @Input({ required: true }) title!: string;

  private readonly _fields = signal<LogisticsCardField[]>([]);
  @Input({ required: true }) set fields(value: LogisticsCardField[]) {
    this._fields.set(value ?? []);
  }

  readonly visibleFields = computed(() =>
    this._fields().filter((f) => {
      if (f.value === null || f.value === undefined) return false;
      if (typeof f.value === 'string') return f.value.trim().length > 0;
      return true;
    })
  );

  private readonly _clipboard = inject(ClipboardService);

  copyValue(value: string | number | null | undefined): void {
    if (value === null || value === undefined) return;
    this._clipboard.copy(String(value));
  }
}
